import * as actions from './inf-location-history.actions';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, from } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { ApiInfMethod } from 'src/app/api/api-methods.inf';
import { InfLocationHistoryI } from 'src/app/api/inf-location-history/inf-location-history.result.int';
import { Injectable, inject } from '@angular/core';
import { SharedGenericService } from 'src/app/shared/services/shared-generic.service';
import { loadingInfLocationHistory } from 'src/app/shared/_config/i18n/i18n-interface';
import { spxSpinnerActions } from '@softpak/components/spx-spinner';
import { spxToasterActions } from '@softpak/components/spx-toaster';

@Injectable()
export class InfLocationHistoryEffects {
    private readonly actions$ = inject(Actions);
    private readonly sharedGenericService = inject(SharedGenericService);

    load$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.load),
        mergeMap(action => from(this.sharedGenericService.invoke(ApiInfMethod.infLocationHistory, action.query))
            .pipe(
                map((result: InfLocationHistoryI) => actions.received({
                    result
                })),
                catchError((error) => {
                    console.error(error);
                    return [
                        actions.error({
                            messageText: error,
                        }),
                        spxToasterActions.createError({
                            autoClose: error.autoclose ? 5000 : undefined,
                            messageText: `${error?.title ? `${error?.title}: ` : ``} ${error.message}`,
                        }),
                    ];
                })
            )))
    );

    afterLoad$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.load),
        mergeMap(() => [
            spxSpinnerActions.show({
                action: loadingInfLocationHistory
            }),
        ]))
    );

    afterError$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.error),
        mergeMap(() => [
            spxSpinnerActions.hide({
                action: loadingInfLocationHistory
            }),
        ]))
    );

    afterReceived$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.received),
        mergeMap(() => [
            spxSpinnerActions.hide({
                action: loadingInfLocationHistory
            }),
        ]))
    );
}
